import { FILTERS, SEARCH } from '../../config'
import { map } from '../../utils/object'
import {
  SearchTypes,
  DEFAULT_DISTANCE,
  JOB,
  SORT_ORDER_RELEVANCE,
  DEFAULT_SEARCH_LOCATION
} from '../constants'

export const defaultOrder = SORT_ORDER_RELEVANCE
export const defaultQuery = {
  name: '',
  location: DEFAULT_SEARCH_LOCATION,
  dist: DEFAULT_DISTANCE,
  order: defaultOrder
}
export const defaultType = JOB
export const defaultShowFirstResult = false
export const defaultShowMobileSearchForm = false
export const defaultFilters = FILTERS.reduce((config, { id }) => ({
  ...config,
  [id]: []
}), {})
export const defaultEmptyQuery = {}
export const defaultSelectedId = null
export const defaultAutoSelectItem = false
export const defaultSourceJobId = null
export const defaultFixed = {
  ...SEARCH.types.job.params
}
export const defaultCollapsedFilters = true
export const defaultUpdateUrl = false
export const defaultResultsMap = map(SearchTypes, (_, searchType) => ({
  selectedId: defaultSelectedId,
  ...(searchType === JOB && { sourceJobId: defaultSourceJobId })
}))
export const defaultHiddenFilters = true

export default {
  query: defaultQuery,
  type: defaultType,
  showFirstResult: defaultShowFirstResult,
  showMobileSearchForm: defaultShowMobileSearchForm,
  filters: defaultFilters,
  results: defaultResultsMap,
  fixed: defaultFixed,
  collapsedFilters: defaultCollapsedFilters,
  updateUrl: defaultUpdateUrl,
  hiddenFilters: defaultHiddenFilters,
  autoSelectItem: defaultAutoSelectItem
}
